import { Box, IconButton } from '@mui/material';
import {
  IconArrowsSort,
  IconMenu,
  IconMenu2,
  IconSortAscending,
  IconSortDescending
} from '@tabler/icons-react';
import React from 'react';
import { ENUM_SORT_DIRECTION } from '../../enums/enums';

export default function CusSort({ name, type, setSortConfig }) {
  return (
    <Box>
      <IconButton
        size="small"
        onClick={() =>
          setSortConfig((prev) => ({
            key: name,
            direction:
              type === ENUM_SORT_DIRECTION.asc ? ENUM_SORT_DIRECTION.desc : ENUM_SORT_DIRECTION.asc
          }))
        }>
        {type === ENUM_SORT_DIRECTION.asc ? (
          <IconSortAscending size={16} />
        ) : type === ENUM_SORT_DIRECTION.desc ? (
          <IconSortDescending size={16} />
        ) : (
          <IconArrowsSort size={16} />
        )}
      </IconButton>
    </Box>
  );
}
